// extracted by mini-css-extract-plugin
module.exports = {"commentsContent":"comments_commentsContent__1rr0v","comment":"comments_comment__1b6r3","deleteIcon":"comments_deleteIcon__rzJhx","customPadding":"comments_customPadding__2DMzP"};